// import React from "react";

// export default function About() {
//   return (
//     <div style={{ fontFamily: "sans-serif", lineHeight: 1.6 }}>

//       {/* 🔥 HERO SECTION */}
//       <div
//         style={{
//           background: "rgb(0,111,47)",
//           color: "#fff",
//           padding: "80px 20px",
//           textAlign: "center",
//         }}
//       >
//         <h1 style={{ fontSize: "36px", marginBottom: "10px" }}>
//           Building Foundations That Last a Lifetime
//         </h1>
//         <p style={{ maxWidth: "800px", margin: "auto" }}>
//           A school is more than walls and textbooks — it is where futures are shaped,
//           values are rooted, and dreams take their very first flight.
//         </p>
//       </div>

//       {/* 🔥 ABOUT TEXT */}
//       <div style={{ padding: "50px 20px", maxWidth: "1100px", margin: "auto" }}>
//         <p>
//           Delhi Public Kids School, Ladwa, proudly serves as a transformative
//           foundation for hundreds of children across the region. Established in
//           2013 under the Vadhera Group of Educational Trust and franchised under
//           Delhi Public School Private Limited, DPS Kids Ladwa is a co-educational,
//           English medium school permanently affiliated with CBSE, New Delhi.
//         </p>
//       </div>

//       {/* 🔥 OUR IDENTITY */}
//       <div style={{ background: "#f6f7fb", padding: "50px 20px" }}>
//         <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
//           Our Identity
//         </h2>

//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//             gap: "20px",
//             maxWidth: "1100px",
//             margin: "auto",
//           }}
//         >
//           {[
//             ["Unit of", "Delhi Public School Pvt. Ltd."],
//             ["Run Under", "Vadhera Shiksha Samiti"],
//             ["Established", "2013"],
//             ["Medium", "English"],
//             ["Type", "Co-Educational"],
//             ["Board", "CBSE, New Delhi"],
//             ["Affiliation", "532056 (Permanent)"],
//             ["Certification", "ISO Certified"],
//           ].map((item, i) => (
//             <div
//               key={i}
//               style={{
//                 background: "#fff",
//                 padding: "20px",
//                 borderRadius: "10px",
//                 boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
//               }}
//             >
//               <h4 style={{ color: "rgb(0,111,47)" }}>{item[0]}</h4>
//               <p>{item[1]}</p>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* 🔥 DPS NETWORK */}
//       <div style={{ padding: "50px 20px", maxWidth: "1100px", margin: "auto" }}>
//         <h2 style={{ marginBottom: "20px" }}>About the DPS Network</h2>
//         <p>
//           Delhi Public Schools have been serving society in the field of education
//           for over 6 decades. With more than 200 schools in India and abroad, DPS
//           has become a symbol of quality education and growth in young minds.
//         </p>
//       </div>

//       {/* 🔥 INFRASTRUCTURE */}
//       <div style={{ background: "#f6f7fb", padding: "50px 20px" }}>
//         <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
//           Infrastructure Highlights
//         </h2>

//         <div
//           style={{
//             maxWidth: "1100px",
//             margin: "auto",
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//             gap: "20px",
//           }}
//         >
//           {[
//             "Smart Classrooms",
//             "Well-Stocked Library",
//             "Playground",
//             "Swimming Pool",
//             "Kindergarten Zone",
//             "Bus Transportation",
//             "CCTV Surveillance",
//             "Day Care & Learning Center",
//           ].map((item, i) => (
//             <div
//               key={i}
//               style={{
//                 background: "#fff",
//                 padding: "20px",
//                 borderRadius: "10px",
//                 textAlign: "center",
//                 boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
//               }}
//             >
//               <h4>{item}</h4>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

 
import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../Screenss/DataContext";
export default function About() {
  const primaryColor = "rgb(0,111,47)";
 const { data } = useContext(DataContext);
 const [current, setCurrent] = useState(0);
const galleryItems = data.filter(
    (item) => item.category === "ourschool"
  );

  // 🔁 Auto Slide
  useEffect(() => {
    if (galleryItems.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === galleryItems.length - 1 ? 0 : prev + 1
      );
    }, 3000); // 3 sec

    return () => clearInterval(interval);
  }, [galleryItems]);

  
  const identityCards = [
    ["Unit of", "Delhi Public School Pvt. Ltd.", "🏢"],
    ["Run Under", "Vadhera Shiksha Samiti", "🤝"],
    ["Established", "2013", "📅"],
    ["Medium", "English", "🌍"],
    ["Type", "Co-Educational", "👫"],
    ["Board", "CBSE, New Delhi", "📜"],
    ["Affiliation", "532056 (Permanent)", "✅"],
    ["Certification", "ISO Certified", "🏅"],
  ];

  const infraItems = [
    "Smart Classrooms",
    "Well-Stocked Library",
    "Playground",
    "Swimming Pool",
    "Kindergarten Zone",
    "Bus Transportation",
    "CCTV Surveillance",
    "Day Care Center",
  ];

  return (
    <div style={styles.page}>
       {/* ✅ HERO SLIDER */}
      <section style={styles.hero}>
        <div style={styles.heroImageWrap}>
          
          {galleryItems.length > 0 && (
            <img
              src={galleryItems[current].full_url}
              alt="school banner"
              style={styles.heroImage}
            />
          )}

          {/* <div style={styles.heroOverlay} /> */}

          {/* <div style={styles.heroContent}>
            <h1 style={styles.heroTitle}>
              Building Foundations That Last a Lifetime
            </h1>
            <p style={styles.heroText}>
              A school is more than walls and textbooks — it is where futures are shaped, values are rooted, and dreams take flight.
            </p>
          </div> */}

          {/* ✅ Dots Indicator */}
          <div style={styles.dots}>
            {galleryItems.map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrent(i)}
                style={{
                  ...styles.dot,
                  backgroundColor:
                    current === i ? "rgb(0,111,47)" : "#fff",
                }}
              />
            ))}
          </div>

        </div>
      </section>

      <section style={styles.aboutText}>
        <h2 style={{ color: primaryColor, marginBottom: "18px", fontSize: "2rem" }}>
          Welcome to DPS Kids Ladwa
        </h2>
        <p style={{ fontSize: "1.05rem", color: "#555", maxWidth: "1000px", margin: "0 auto" }}>
          Established in 2013 under the Vadhera Group of Educational Trust, we proudly serve as a transformative
          foundation for hundreds of children. Franchised under Delhi Public School Private Limited, we are a
          co-educational, English medium school permanently affiliated with CBSE, New Delhi.
        </p>
      </section>

      <section style={styles.identitySection}>
        <h2 style={styles.sectionHeading}>Our Identity</h2>
        <div style={styles.identityGrid}>
          {identityCards.map((item, i) => (
            <div key={i} className="identity-card" style={styles.identityCard}>
              <div style={styles.identityIcon}>{item[2]}</div>
              <h4 style={styles.identityTitle}>{item[0]}</h4>
              <p style={styles.identityText}>{item[1]}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={styles.networkSection}>
        <h2 style={{ marginBottom: "14px", color: primaryColor, fontSize: "2rem" }}>
          The DPS Network
        </h2>
        <p style={styles.networkText}>
          Delhi Public Schools have been serving society for over 6 decades. With more than 200 schools worldwide,
          DPS is a global symbol of quality education and holistic growth.
        </p>
      </section>

      <section style={styles.infraSection}>
        <h2 style={styles.infraHeading}>Infrastructure Highlights</h2>
        <div style={styles.infraGrid}>
          {infraItems.map((item, i) => (
            <div key={i} className="infra-card" style={styles.infraCard}>
              {item}
            </div>
          ))}
        </div>
      </section>

      <style>{`
        .identity-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 18px 35px rgba(0,111,47,0.18);
          border-color: rgba(0,111,47,0.22);
        }

        .infra-card:hover {
          transform: translateY(-6px) scale(1.03);
          background: #fff;
          color: rgb(0,111,47);
          box-shadow: 0 14px 28px rgba(0,0,0,0.12);
        }

        @media (max-width: 768px) {
          .identity-grid, .infra-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
}

// const styles = {
//   page: {
//     fontFamily: "'Poppins', sans-serif",
//     lineHeight: 1.7,
//     backgroundColor: "#fff",
//     overflowX: "hidden",
//   },
//   hero: {
//     width: "100%",
//     marginTop: "120px",
//   },
//   heroImageWrap: {
//     position: "relative",
//     width: "100%",
//     height: "560px",
//     overflow: "hidden",
//     marginTop:140
//   },
//   heroImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//   },
//   heroOverlay: {
//     position: "absolute",
//     inset: 0,
//     background: "rgba(0,0,0,0.45)",
//   },
//   heroContent: {
//     position: "absolute",
//     inset: 0,
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     color: "#fff",
//     padding: "0 20px",
//   },
//   heroTitle: {
//     fontSize: "3rem",
//     fontWeight: "800",
//     marginBottom: "15px",
//     maxWidth: "900px",
//   },
//   heroText: {
//     maxWidth: "760px",
//     fontSize: "1.1rem",
//     opacity: 0.92,
//   },
//   aboutText: {
//     padding: "50px 20px 70px",
//     maxWidth: "1100px",
//     margin: "auto",
//     textAlign: "center",
//   },
//   identitySection: {
//     background: "#f0f9f4",
//     padding: "80px 20px",
//   },
//   sectionHeading: {
//     textAlign: "center",
//     marginBottom: "50px",
//     fontSize: "2.4rem",
//     color: "#222",
//   },
//   identityGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
//     gap: "25px",
//     maxWidth: "1150px",
//     margin: "auto",
//   },
//   identityCard: {
//     background: "#fff",
//     padding: "30px",
//     borderRadius: "20px",
//     textAlign: "center",
//     boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
//     borderBottom: `4px solid rgb(0,111,47)`,
//     transition: "0.35s ease",
//   },
//   identityIcon: {
//     fontSize: "2.4rem",
//     marginBottom: "15px",
//   },
//   identityTitle: {
//     color: "rgb(0,111,47)",
//     marginBottom: "10px",
//     fontSize: "1.1rem",
//   },
//   identityText: {
//     fontWeight: "600",
//     color: "#333",
//     margin: 0,
//   },
//   networkSection: {
//     padding: "80px 20px",
//     textAlign: "center",
//     background: "#fff",
//   },
//   networkText: {
//     maxWidth: "900px",
//     margin: "auto",
//     fontSize: "1.05rem",
//     color: "#666",
//   },
//   infraSection: {
//     background: "rgb(0,111,47)",
//     padding: "80px 20px",
//     borderRadius: "50px 50px 0 0",
//   },
//   infraHeading: {
//     textAlign: "center",
//     marginBottom: "50px",
//     color: "#fff",
//     fontSize: "2.4rem",
//   },
//   infraGrid: {
//     maxWidth: "1100px",
//     margin: "auto",
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//     gap: "20px",
//   },
//   infraCard: {
//     background: "rgba(255,255,255,0.12)",
//     backdropFilter: "blur(10px)",
//     padding: "24px",
//     borderRadius: "16px",
//     textAlign: "center",
//     color: "#fff",
//     border: "1px solid rgba(255,255,255,0.2)",
//     transition: "0.35s ease",
//     fontWeight: "600",
//   },
// };

const styles = {
  page: {
    fontFamily: "'Poppins', sans-serif",
    lineHeight: 1.7,
    backgroundColor: "#fff",
    overflowX: "hidden",
  },

  hero: {
    width: "100%",
    marginTop: "clamp(80px, 10vw, 120px)", // 🔥 responsive
  },

  heroImageWrap: {
    position: "relative",
    width: "100%",
    height: "clamp(280px, 50vw, 560px)", // 🔥 FIXED HEIGHT → responsive
    overflow: "hidden",
    marginTop: "clamp(60px, 8vw, 140px)", // 🔥 responsive spacing
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },

  heroOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
  },

  heroContent: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#fff",
    padding: "0 clamp(12px, 4vw, 20px)", // 🔥 responsive padding
  },

  heroTitle: {
    fontSize: "clamp(24px, 5vw, 48px)", // 🔥 responsive
    fontWeight: "800",
    marginBottom: "12px",
    maxWidth: "900px",
  },

  heroText: {
    maxWidth: "760px",
    fontSize: "clamp(13px, 2vw, 18px)", // 🔥 responsive
    opacity: 0.92,
  },

  aboutText: {
    padding: "clamp(30px, 6vw, 50px) 15px clamp(40px, 6vw, 70px)", // 🔥 spacing fix
    maxWidth: "1100px",
    margin: "auto",
    textAlign: "center",
  },

  identitySection: {
    background: "#f0f9f4",
    padding: "clamp(40px, 8vw, 80px) 15px", // 🔥 responsive
  },

  sectionHeading: {
    textAlign: "center",
    marginBottom: "clamp(25px, 6vw, 50px)",
    fontSize: "clamp(20px, 4vw, 38px)", // 🔥 responsive
    color: "#222",
  },

  identityGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", // 🔥 better fit
    gap: "clamp(15px, 3vw, 25px)",
    maxWidth: "1150px",
    margin: "auto",
  },

  identityCard: {
    background: "#fff",
    padding: "clamp(20px, 4vw, 30px)",
    borderRadius: "20px",
    textAlign: "center",
    boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
    borderBottom: `4px solid rgb(0,111,47)`,
    transition: "0.35s ease",
  },

  identityIcon: {
    fontSize: "clamp(24px, 4vw, 38px)", // 🔥 responsive
    marginBottom: "10px",
  },

  identityTitle: {
    color: "rgb(0,111,47)",
    marginBottom: "8px",
    fontSize: "clamp(14px, 2vw, 18px)",
  },

  identityText: {
    fontWeight: "600",
    color: "#333",
    margin: 0,
    fontSize: "clamp(13px, 2vw, 15px)",
  },

  networkSection: {
    padding: "clamp(40px, 8vw, 80px) 15px",
    textAlign: "center",
    background: "#fff",
  },

  networkText: {
    maxWidth: "900px",
    margin: "auto",
    fontSize: "clamp(13px, 2vw, 17px)",
    color: "#666",
  },

  infraSection: {
    background: "rgb(0,111,47)",
    padding: "clamp(40px, 8vw, 80px) 15px",
    borderRadius: "clamp(20px, 5vw, 50px) clamp(20px, 5vw, 50px) 0 0", // 🔥 responsive radius
  },

  infraHeading: {
    textAlign: "center",
    marginBottom: "clamp(25px, 6vw, 50px)",
    color: "#fff",
    fontSize: "clamp(20px, 4vw, 38px)",
  },

  infraGrid: {
    maxWidth: "1100px",
    margin: "auto",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "clamp(12px, 3vw, 20px)",
  },

  infraCard: {
    background: "rgba(255,255,255,0.12)",
    backdropFilter: "blur(10px)",
    padding: "clamp(16px, 3vw, 24px)",
    borderRadius: "16px",
    textAlign: "center",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.2)",
    transition: "0.35s ease",
    fontWeight: "600",
    fontSize: "clamp(13px, 2vw, 15px)",
  },
};